import { useState, useMemo, useEffect } from 'react';
import { Button, SubHeader } from '@component';
import { NewUserForm } from './NewUserForm';
import { UsersTable } from './Table';
import { debounce } from 'lodash';

export const UserManagementList = () => {
  const [item, setItem] = useState(null);
  const [updatedOn, setUpdatedOn] = useState(new Date());
  const [filter, setFilter] = useState('');
  const [searchString, setSearchString] = useState('');

  const newItem = {
    firstName: '',
    lastName: '',
    email: '',
    role: '',
    displayName: '',
    password: '',
    uid: '',
    country: '',
    state: '',
    stateCode: '',
    country_code: '',
  };

  const columns = useMemo(
    () => [
      { Header: 'First Name', accessor: 'firstName' },
      { Header: 'Last Name', accessor: 'lastName' },
      { Header: 'Country', accessor: 'country' },
      { Header: 'Email', id: 'email', accessor: ({ email }) => <a href={`mailto:${email}`}>{`${email}`}</a> },
      {
        Header: 'Role',
        accessor: ({ role }) => {
          if (!role) return 'App User';
          switch (role) {
            case 'admin':
              return 'CMS Admin';
            case 'viewer':
              return 'CMS Viewer';
            case 'editor':
              return 'CMS Editor';
            default:
              return role;
          }
        },
      },
      // {
      //   Header: 'Last Active',
      //   id: 'lastActive',
      //   accessor: ({ metadata }) => format(new Date(metadata.lastSignInTime), 'Pp'),
      // },
    ],
    []
  );

  return (
    <>
      <SubHeader title="User Management"></SubHeader>
      <div className="bg-white p-4 m-4 rounded-md mx-4 items-center">
        <div className="flex justify-between items-center mb-4">
          <FilterInput setFilter={setFilter}></FilterInput>
          <Button onClick={() => setItem(newItem)}>Add New User</Button>
        </div>
        <UsersTable
          columns={columns}
          version={updatedOn}
          onViewRow={row => setItem({ ...newItem, ...row })}
          className="mt-4"
          filter={filter}
          defaultSortBy={[{ id: 'firstName' }]}
        />
        <NewUserForm item={item} close={() => {
          setFilter('');
          setItem(null);
        }
        } saved={
          () => setUpdatedOn(new Date())}></NewUserForm>
      </div>
    </>
  );
};

function FilterInput({ setFilter }) {
  const debouncedOnChange = useMemo(() => debounce(value => setFilter(value.toLowerCase()), 1000), [setFilter]);

  useEffect(() => {
    return () => debouncedOnChange.cancel();
  }, [debouncedOnChange]);

  return (
    <input
      type="text"
      onChange={e => debouncedOnChange(e.target.value)}
      className="border border-gray-100 rounded-md p-2"
      placeholder="Search by email"
    />
  );
}
